export default __webpack_public_path__ + "static/social-estados-ranking-2fc6b510553bcfd4d102bdb46c3c25c5.png";